import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68348d95"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ordered-goods" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "goods-list" }
const _hoisted_4 = { id: "popup-goods" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "transparent" }, null, -1))
const _hoisted_8 = { class: "number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t("ORDER.ORDERED_GOODS")), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsToDisplay, (product) => {
        return (_openBlock(), _createElementBlock("div", {
          key: product,
          class: "img-wrapper",
          "data-cy": "product"
        }, [
          _createElementVNode("div", {
            class: "good-picture",
            style: _normalizeStyle(
            'background-image: url(' +
              product.imageUrl +
              '), url(' +
              require(`@/assets/images/image-not-found-${_ctx.lang}.jpg`) +
              ')'
          )
          }, null, 4),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(product.name), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(product.pieces) + " ks, " + _toDisplayString(product.price.value) + _toDisplayString(_ctx.t("CURRENCY.CURRENCY")), 1)
          ])
        ]))
      }), 128)),
      (_ctx.hasMorethanXProducts)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hasClickedOnMore = true)),
            class: "img-wrapper-more",
            "data-cy": "more-products"
          }, [
            (_ctx.orderItems.length > _ctx.noOfProductsToDisplay)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "good-picture",
                  style: _normalizeStyle(
            'background-image: url(' +
              _ctx.orderItems[_ctx.noOfProductsToDisplay].imageUrl +
              '), url(' +
              require(`@/assets/images/image-not-found-${_ctx.lang}.jpg`) +
              ')'
          )
                }, null, 4))
              : _createCommentVNode("", true),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, " +" + _toDisplayString(_ctx.getAllProductsLength - _ctx.noOfProductsToDisplay), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}